<div class="full-width-header header-style1 home8-style4">
  <main-menu></main-menu>
</div>
<!-- Main content Start -->
<div class="main-content">
  <div class="rs-breadcrumbs breadcrumbs-overlay">
    <div class="breadcrumbs-img">
      <img src="assets/images/breadcrumbs/2.jpg" alt="Breadcrumbs Image">
    </div>
    <div class="breadcrumbs-text white-color">
      <h1 class="page-title">Anti Ragging Committee</h1>
      <ul>
        <li><a class="active" routerLink="/home">Home</a></li>
        <li>Anti Ragging Committee</li>
      </ul>
    </div>
  </div>

  <div class="rs-inner-blog orange-color pt-100 pb-100 md-pt-70 md-pb-70 committee-section">
    <div class="container">
      <div class="row">
        <div class="col-lg-4 col-md-12 pr-50 md-pr-15">
          <div class="widget-area">
            <div class="widget-archives footer-widget mb-50">
              <h3 class="widget-title">Committees</h3>
              <ul>
                <li class="menu-item-has-children" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: false }">
                  <ul class="sub-menu">
                    <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"><a routerLink="/anti-ragging-committee">Anti Ragging Committee</a></li>
                    <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"><a routerLink="/grievance-reddressal-committee">Grievance Reddressal Committee</a></li>
                    <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"><a routerLink="/internal-complaints-committee">Internal Complaints Committee</a></li>
                    <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"><a routerLink="/sc-and-st-grievance-committee">SC &amp; ST Grievance Committee</a></li>
                    <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"><a routerLink="/internal-quality-assurance-committee">Internal Quality Assurance Committee</a></li>
                    <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"><a routerLink="/institution-industry-cell">Institution Industry Cell</a></li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="col-lg-8">
          <div class="committee-content-wrap">
            <h2 class="committee-main-title">Anti Ragging Committee</h2>

            <p class="committee-paragraph">
              ANTI RAGGING COMMITTEE is our apex body at Institutional level to monitor measures for preventing,
              prohibiting and punishing activities of Ragging Menace within and outside the campus in accordance with
              UGC Regulations. Supreme Court Directives and Provisions State Act., It is responsible for taking action
              against those found guilty of ragging and/or abetting ragging, actively or passively or being part of
              the conspiracy to promote ragging. The college has formed the following anti-ragging committees and
              squads for overseeing the implementation of the provisions of the verdict with immediate effect.
            </p>

            <p class="blog-table-wrap">
              <a href="/assets/college/Committees/anti_ragging_2024-25.pdf" target="_blank">Anti Ragging Committee (click to view)</a>
            </p>

            <blockquote class="committee-note">
              RAGGING means doing an activity that causes or is likely to cause insult or annoyance of fear or
              apprehension or threat or intimidation or outrage of modesty or injury to a junior student.
            </blockquote>

            <h4 class="committee-footer-title">UGC REGULATIONS ON CURBING THE MENACE OF RAGGING IN HIGHER EDUCATIONAL INSTITUTIONS</h4>

            <div class="row ugc-row">
              <div class="col-lg-4 ugc-image-col">
                <img src="https://jntuanotifications.blob.core.windows.net/websites/icons/AntiRagging1.jpg" alt="Ragging is strictly prohibited" class="ugc-image">
              </div>
              <div class="col-lg-8 ugc-text-col">
                <p class="committee-paragraph">
                  In exercise of the powers conferred by Clause (g) of Sub-Section 26 of the University Grants
                  Commission Act, 1956, the University Grants Commission hereby makes the Regulations
                  "UGC Regulations on Curbing the Menace of Ragging in Higher Educational Institutions" in force with
                  immediate effect.
                </p>
                <p class="committee-paragraph">
                  To root out ragging in all its forms from universities, colleges, and other educational institutions
                  in the country by prohibiting it by law, preventing its occurrence by following the provisions of
                  these Regulations and punishing those who indulge in ragging as provided for in these Regulations and
                  the appropriate law in force.
                </p>
              </div>
            </div>

            <h4 class="committee-mini-title">Ingredients of Ragging</h4>

            <div class="row ugc-row ugc-row-2">
              <div class="col-lg-4 ugc-image-col">
                <img src="https://jntuanotifications.blob.core.windows.net/websites/icons/AntiRagging2.jpg" alt="Anti Ragging Zone" class="ugc-image">
              </div>
              <div class="col-lg-8 ugc-text-col">
                <p class="committee-paragraph">
                  Depending upon the nature and gravity of the offense as established by the Anti- Ragging Committee
                  of the institution, the possible punishments for those found guilty of ragging at the institution
                  level shall be anyone or any combination of the following:
                </p>
              </div>
            </div>

            <ul class="punishment-list listing-style">
              <li>Suspension from attending classes and academic privileges</li>
              <li>Withholding/withdrawing scholarship/fellowship and other benefits</li>
              <li>Debarring from appearing in any test/examination or other evaluation process Withholding results</li>
              <li>Debarring from representing the institution in any regional, national or international meet, tournament, youth festival, etc;</li>
              <li>Suspension/expulsion from the hostel</li>
              <li>Cancellation of admission</li>
              <li>Rustication from the institution for period ranging from 1 to 4 semesters</li>
              <li>Expulsion from the institution and consequent debarring from admission to any other institution for a specified period</li>
              <li>Fine ranging between Rupees 25,000/- and Rupees 1 lakh</li>
              <li>Collective punishment: When the persons committing or abetting the crime of ragging are not identified, the institution shall resort to collective punishment.</li>
            </ul>

            <h4 class="committee-mini-title">The AP Prohibition Of Ragging In Educational Institutions Act, 1997</h4>

            <ul class="punishment-list listing-style">
              <li>Ragging within or outside any educational institution is prohibited.</li>
              <li>Ragging means doing an act that causes or is likely to cause insult or annoyance or fear or apprehension or threat or intimidation or outrage of modesty or injury to a student.</li>
              <li>Ragging is prohibited as per Act 26 of A.P Legislative Assembly, 1997.</li>
              <li>Ragging entails heavy fines and or imprisonment.</li>
              <li>Ragging invokes suspension and dismissal from the college.</li>
              <li>Outsiders are prohibited from entering the college and Hostel without permission.</li>
              <li>All the students must carry their identity cards and show them when demanded.</li>
            </ul>

            <h4 class="committee-mini-title">Punishments Under Ap Prohibition Of Ragging Act 1997</h4>

            <div class="blog-table-wrap">
              <table class="blog-table ap-table">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>NATURE OF RAGGING</th>
                    <th>PUNISHMENT</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1</td>
                    <td>Teasing, embarrassing and humiliating</td>
                    <td>Imprisonment up to 6 months or fine up to Rs.1,000.00 or both</td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>Assaulting or using criminal force or criminal intimidation</td>
                    <td>Imprisonment up to 1 year or fine up to Rs.2,000.00 or both.</td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td>Wrongfully restraining or confining or causing hurt</td>
                    <td>Imprisonment up to 2 years or fine up to Rs.5,000.00 or both.</td>
                  </tr>
                  <tr>
                    <td>4</td>
                    <td>Causing grievous hurt, kidnapping or rape or committing unnatural offense</td>
                    <td>Imprisonment up to 5 Years and fine up to Rs.10,000.00</td>
                  </tr>
                  <tr>
                    <td>5</td>
                    <td>Causing Death or abetting suicide</td>
                    <td>Imprisonment up to 10 Years and up to Rs. 50,000.00</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <h4 class="committee-mini-title">Note</h4>

            <ul class="punishment-list listing-style">
              <li>A student convicted of any of the above offenses, will be expelled from the college.</li>
              <li>A student imprisoned for more than six months for any of the above offenses will not be admitted to any other college.</li>
              <li>A student against whom there is prima facie evidence of ragging in any form will be suspended from the college immediately.</li>
            </ul>

            <h3 class="helpline-title">National Anti Ragging Help Line (UGC Crisis Hotline)</h3>
            <p class="helpline-contact">24x7 Toll Free Number* 1800-180-5522</p>
            <p class="helpline-contact">(helpline@antiragging.in)</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Newsletter section start -->
  <app-subscribe></app-subscribe>
  <!-- Newsletter section end -->
</div>
<!-- Main content End -->

